import { createReducer } from '@reduxjs/toolkit'
import { DictT, InvitationT } from 'shared/types/model'
import { receiveInvitations, clear, logout } from 'model/actions'

const initialState = {} as DictT<InvitationT>

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveInvitations, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
